import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { profileRoute } from '..'

const ReferralLayout = lazyRouteComponent(() => import('../../../pages/profile/referral'))

export type ReferralSearch = {
  referral_id?: string
}

export const referralRoute = createRoute({
  getParentRoute: () => profileRoute,
  path: 'referral',
  component: ReferralLayout,
  validateSearch: (search: Record<string, unknown>): ReferralSearch => {
    return search
  },
})
